import React, { useState, useEffect } from 'react';
import Button from '../../Atoms/Button/Button';
import Modal from '../Modal/Modal';
import {
  toastBannerAnalytics,
  updateOrderViewModel,
} from '../../../Utils/componentUtils';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import './CartModal.scss';
import { AddToCartFavoriteResponse, CartModalProps } from '../../Interfaces/CartModalInterface';
import { productString } from '../../Analytics/AnalyticsNew';
import useStore from '../../../store/useStore';
import {
  CONTINUE,
  DEAL_NOT_AVAILABLE_ERROR_MODAL,
  ERROR_MESSAGE,
  ERROR_WARNING_MODAL,
  FALLBACK_FAV_ERROR,
  FAVORITE,
  FAVORITE_SOURCE,
  MODAL_PAGEVIEW,
  OUT_OF_STOCK_MODAL,
  REMOVE_ITEMS_CONTINUE,
} from '../../../constants/AnalyticsConstants';
import ErrorModal from './ErrorModal';
import useRequest from '../../../hooks/useRequest';
import { componentRenderCheck, multipleAndCheck, multipleOrCheck, navigateToMenu, ternaryCheck } from '../../../Utils/WindowUtils';
import {
  getProductsItems,
  preparePayloadForUnavailableModal,
} from '../../Organisms/RecentOrdersList/RecentOrderUtils';
import Heading from '../../Atoms/Heading/Heading';
import {
  navigateToLocatorPage,
} from '../../Organisms/DeliveryLocator/DeliveryLocatorUtils';
import { getOrderType } from '../../../Utils/Utils';
import {
  onClickContinueAnalytics,
  getContinueButtonText,
  onClickStartOrder,
  checkRemoveAndContinue,
  checkRecentOrderReorder,
  redirectToOrdermanagement,
  handleRedirection,
  checkForAttemptTracker,
  updateOrderViewModelDeliveryAddress
} from './CartModalUtils';
import {
  CANCEL_DELIVERY_BTN,
  CONTINUE_BTN,
  FIND_ANOTHER_RESTAURANT_BTN,
  FIND_NEW_LOCATION_ACCEPT_BTN,
  FIND_NEW_LOCATION_CANCEL_BTN,
  KEEP_SHOPPING_BTN,
  RETURN_TO_BAG,
  START_NEW_ORDER_BTN,
  START_ORDER_LINK,
  SWITCH_LOCATION_BTN,
  SWITCH_TO_PICKUP_BTN
} from '../../../constants/ContextConstants';
import { GREY } from '../../../constants/App';

/**
 * Reusable Cart Modal component for cart and unavailable items and error messages
 * @param param0.favoriteCartData get favorite data to be added to cart
 * @param param0.favDictonary get favorite dictionary
 * @param param0.unavailableApiEndPoint get unavailable api endpoint
 * @returns Reusable modal component
 */

const CartModal: React.FC<CartModalProps> = ({
  favDictonary,
  unavailableData = [],
  isItemAvailable,
  unavailableApiEndPoint,
  cartItemId,
  errorData,
  showModal,
  updateModal,
  okText,
  siteName,
  orderViewModel,
  storeClose,
  language,
  productName,
  isRecentOrderPage,
  isRecentorderReorder,
  showOnlyReorderShoppingCTA = false,
  showOnlyReorderStartCTA = false,
  itemsData,
  value,
  storeId,
  orderType,
  deliveryAddress,
  cancelAndKeepDelivery,
  isShowOk,
  isLocatorPage,
  addToBagSource,
  bundleItemId = [],
  payUrl,
  isAllItemUnavailable = false,
  isSwitchStoreAddress = '',
  dataSourceId = '',
  isCartPage = false,
  removeAndContinueRequest
}) => {
  const [title, setTitle] = useState<string>('');
  const [description, setDescription] = useState<string>('');
  const [isClosebtn, setIsClosebtn] = useState<boolean>(true);
  const [isError, setIsError] = useState<boolean>(false);
  const {
    setAnalyticsProducts,
    setAttemptTracker,
    removedProductData,
    setCartQuantity,
    setContextLoader,
  } = useStore();
  const recentOrderTitle = ternaryCheck(!!isRecentOrderPage, 'Recent order', FAVORITE);
  const recentOrderVirtual =
    ternaryCheck(multipleOrCheck(isRecentOrderPage, isLocatorPage), OUT_OF_STOCK_MODAL, FALLBACK_FAV_ERROR);
  const componentTitle = ternaryCheck(!!isLocatorPage, '', recentOrderTitle);
  const setTextData = (titles: string, descriptions: string) => {
    setTitle(titles);
    setDescription(descriptions);
  };
  const favoriteCartData = _get(unavailableData, ['0'], {});
  const { postRequest: mutateData, error } = useRequest({ isOnClick: true });
  const virtualName = ternaryCheck(favoriteCartData?.isDealNotAvailable,
    DEAL_NOT_AVAILABLE_ERROR_MODAL,
    recentOrderVirtual);
  const goToBagPage = () => {
    orderViewModel.store.id = (window as any).subwayScript.checkSatelliteNumber(orderViewModel.selectedStoreId);
    orderViewModel.save();
    window.location.href = window.subwayScript.navigation.getOrderManagementUrl();
  }
  useEffect(() => {
    if (!_isEmpty(favoriteCartData) && !storeClose) {
      setTextData(favDictonary.errorTitle, favDictonary.errorDescription);
      if (!favoriteCartData.isAvailable) {
        const productDetails = {
          categoryName: _get(favoriteCartData, ['item', 'analytics', 'categoryName'], ''),
          productName: _get(favoriteCartData, ['item', 'analytics', 'productName'], ''),
          productId: _get(favoriteCartData, ['item', 'productId'], ''),
          price: favoriteCartData.price,
          quantity: '',
          size: favoriteCartData.productName,
        };
        setAnalyticsProducts({
          virtualName: virtualName,
          warningMessage:
            favDictonary.errorTitle ?? favDictonary.productOutOfStock ?? favDictonary.productError,
          warningMessageUI: 1,
          componentTitle: componentTitle,
          clickActionName: productName,
          products: productString(favoriteCartData.item, productDetails, '', '', componentTitle),
        });
        setAttemptTracker([{ name: 'modal_pageview' }]);
        return;
      }
      if (!favoriteCartData.areAllIngredientsAvailable) {
        const productDetails = {
          categoryName: _get(favoriteCartData, ['item', 'analytics', 'categoryName'], ''),
          productName: _get(favoriteCartData, ['item', 'analytics', 'productName'], ''),
          productId: _get(favoriteCartData, ['item', 'productId'], ''),
          price: favoriteCartData.price,
          quantity: '',
          size: favoriteCartData.productName,
        };
        setAnalyticsProducts({
          warningMessage: `${favDictonary.unavailableItems ?? favDictonary.itemError}${favoriteCartData.outofStockItems}`,
          warningMessageUI: 1,
          virtualName: virtualName,
          componentTitle: componentTitle,
          clickActionName: productName,
          products: productString(
            favoriteCartData.item,
            productDetails,
            favoriteCartData.outofStockItems,
            '',
            'favorite',
          ),
        });
        setAttemptTracker([{ name: 'modal_pageview' }]);
        return;
      }
    }
    const errorDisctionay: any = _get(errorData, 'response.data.responseBody.error', null) ?? _get(errorData, 'response.data.error', null);
    if (errorDisctionay) {
      setIsError(true);
      setTextData(errorDisctionay.title, errorDisctionay.message);
      setIsClosebtn(true);
      if (favoriteCartData?.isDealNotAvailable) {
        setAnalyticsProducts({
          virtualName: DEAL_NOT_AVAILABLE_ERROR_MODAL,
          warningMessageUI: 1,
          warningMessage: errorDisctionay.title,
        });
        setAttemptTracker([{ name: MODAL_PAGEVIEW }]);
      } else {
        setAnalyticsProducts({
          errorMessage: errorDisctionay.message,
          errorMessageMW: 1,
          errorMessageEvent: 1,
          componentTitle: componentTitle,
          clickActionName: productName,
          parentErrorCode: errorDisctionay.parentCode,
          childErrorCode: errorDisctionay.errorCode,
          virtualName: ERROR_WARNING_MODAL,
        });
        setAttemptTracker([{ name: ERROR_MESSAGE }]);
      }
    }
    if (storeClose) {
      setIsClosebtn(false);
      setAnalyticsProducts({
        warningMessage: favDictonary.storeCloseNewErrorMessage,
        warningMessageUI: 1,
        componentTitle: componentTitle,
        clickActionName: productName,
        virtualName: 'select a new restaurant modal',
      });
      setAttemptTracker([{ name: value, isClickable: true }, { name: 'modal_pageview' }]);
      setTextData(favDictonary.storeCloseSubErrorMessage, favDictonary.storeCloseNewErrorMessage);
    }
  }, []);

  const onClickContinue = async () => {
    setContextLoader({
      buttonId: CONTINUE_BTN,
    });
    setAnalyticsProducts({
      clickActionName: ternaryCheck(!!isRecentOrderPage, REMOVE_ITEMS_CONTINUE, CONTINUE),
      virtualName: virtualName,
      componentTitle: virtualName,
    });
    const order_Detail = {
      siteName: siteName,
      storeId: window.subwayScript.checkSatelliteNumber(storeId),
      orderType: orderType,
      deliveryAddress: deliveryAddress,
    };

    const payload = preparePayloadForUnavailableModal(
      isRecentOrderPage,
      isRecentorderReorder,
      cartItemId,
      orderViewModel,
      itemsData,
      order_Detail,
      ternaryCheck(!!isLocatorPage, _get(favDictonary, ['removeAndContinue'], null), ''),
      bundleItemId,
      isSwitchStoreAddress,
      dataSourceId
    );
    if (isCartPage) {
      removeAndContinueRequest?.({
        ...payload,
        apiEndpoint: unavailableApiEndPoint,
      });
      return;
    }

    await mutateData({
      ...payload,
      apiEndpoint: unavailableApiEndPoint,
    }).then((res: AddToCartFavoriteResponse) => {
      if (res) {
        checkRemoveAndContinue(res, orderViewModel);
        updateModal();
        let productStringData;
        if (isLocatorPage) {
          productStringData = getProductsItems(
            _get(res, ['removeAndContinueMaintainCartResponse', 'items']),
            isLocatorPage,
          );
        } else if (isRecentOrderPage) {
          productStringData = getProductsItems(res.currentItemResponse);
        } else {
          const productDetails = {
            categoryName: _get(res, ['cartCurrentItem', 'analytics', 'categoryName'], ''),
            productName: _get(res, ['cartCurrentItem', 'analytics', 'productName'], ''),
            productId: _get(res, ['cartCurrentItem', 'productId'], ''),
            price: _get(res, ['cartCurrentItem', 'totalLineItemPrice'], 0),
            quantity: _get(res, ['cartCurrentItem', 'quantity'], 1),
            size: _get(res, ['cartCurrentItem', 'productName'], ''),
          };
          productStringData = productString(
            res.cartCurrentItem,
            productDetails,
            '',
            `${addToBagSource}-favorites`,
            FAVORITE_SOURCE,
          );
        }

        const toastedEvent = _get(productStringData, [0, 'ingredients', 'breadType'], []);
        const upsellProductEvent = _get(productStringData, [0, 'additionalItem'], {});
        const mergeCart = orderViewModel.currentOrder.cartQuantity > 0;
        const previosQuantity = orderViewModel.currentOrder.cartQuantity;
        updateOrderViewModel(orderViewModel, !_isEmpty(_get(res, 'removeAndContinueMaintainCartResponse', {})) ? res?.removeAndContinueMaintainCartResponse : res);
        const qunatityOfCart = _get(res, ['cartItemQuantity'], 0) || _get(res, ['cartQuantity'], 0);
        setCartQuantity(qunatityOfCart);
        const orderTypeValue = getOrderType(isRecentOrderPage, isLocatorPage);
        const actionName = ternaryCheck(multipleOrCheck(isRecentOrderPage , isLocatorPage) , REMOVE_ITEMS_CONTINUE , CONTINUE);
        const titleComp =
          ternaryCheck(multipleOrCheck(isRecentOrderPage , isLocatorPage) , OUT_OF_STOCK_MODAL , FALLBACK_FAV_ERROR);
        const nameVirtual =
          ternaryCheck(multipleOrCheck(isRecentOrderPage , isLocatorPage) , OUT_OF_STOCK_MODAL , FALLBACK_FAV_ERROR);
        const onClickContinueAnalyticsData = {
          orderViewModel: orderViewModel,
          toastedEvent: toastedEvent,
          upsellProductEvent: upsellProductEvent,
          productStringData: productStringData,
          mergeCart: mergeCart,
          orderTypeValue: orderTypeValue,
          actionName: actionName,
          titleComp: titleComp,
          nameVirtual: nameVirtual,
          removedProductData: removedProductData,
          isLocatorPage: isLocatorPage,
          cartItemId: cartItemId,
          setAnalyticsProducts: setAnalyticsProducts,
        };
        onClickContinueAnalytics(onClickContinueAnalyticsData);
        checkForAttemptTracker(setAttemptTracker, isLocatorPage)
        !isLocatorPage && localStorage.setItem('cartProgressBar', qunatityOfCart);
        checkRecentOrderReorder( {res, mergeCart, orderViewModel, isRecentorderReorder, orderType} )

        orderViewModel.cartOpen = false;
        orderViewModel.save();
        setTimeout(() => {
          isRecentOrderPage &&
            toastBannerAnalytics(
              setAnalyticsProducts,
              setAttemptTracker,
              favDictonary.addToBagSuccessMsg,
            );
          redirectToOrdermanagement(res, previosQuantity, isRecentorderReorder)
          handleRedirection(res, orderViewModel, isLocatorPage)
        }, 1000);
      }
    });
  };

  const onClickSwitch = (btnText: string, isLocation: boolean) => {
    if (isLocation) {
      setAnalyticsProducts({
        clickActionName: btnText,
        componentTitle: FALLBACK_FAV_ERROR,
        virtualName: FALLBACK_FAV_ERROR,
      });
      setAttemptTracker([{ name: value, isClickable: true }]);
    } else {
      setAnalyticsProducts({
        clickActionName: btnText,
        virtualName: 'select a new restaurant modal',
      });
      setAttemptTracker([{ name: 'modal_cta', isClickable: true }]);
    }
    setTimeout(() => {
      window.location.href = `/${language}/locator`;
    }, 500);
  };

  const onClickKeepShopping = () => {
    setContextLoader({
      buttonId: KEEP_SHOPPING_BTN,
    });
    setAnalyticsProducts({
      clickActionName: 'keep shopping',
      componentTitle: virtualName,
      virtualName: virtualName,
    });
    setAttemptTracker([{ name: 'recent_order', isClickable: true }]);
    setTimeout(() => {
      navigateToMenu();
    }, 1000);
  };
  const showDescription = () => {
    if (multipleAndCheck(isRecentOrderPage , !storeClose)) {
      return favDictonary?.errorDescription ?? description;
    }
    return description;
  };

  const favProductDetail = (data: any) => {
    if (multipleOrCheck(data?.isAvailable === false , data?.isItemUnavailable === true)) {
      return favDictonary.productOutOfStock ?? favDictonary.productError;
    } else if (data.isComboProductMissingAndIsMeal && _isEmpty(data.outofStockItems)) {
      return '';
    } else {
      return ternaryCheck(multipleOrCheck(data?.areAllIngredientsAvailable === false || data?.isComboUnavailable)
        , `${favDictonary.unavailableItems ?? favDictonary.itemError} ${data.outofStockItems}`
        , null);
    }
  };
  const checkItemUnAvailability = (data: any) => {
    return !data?.areAllIngredientsAvailable || !data?.isAvailable || data?.isComboUnavailable;
  };
  const showButtons = (action: string) => {
    const list = unavailableData?.filter((data: any) => {
      if (action == 'start order') {
        return multipleOrCheck(!data?.areAllIngredientsAvailable , !data?.isAvailable);
      } else if (action == 'keep shopping') {
        return multipleAndCheck(!data?.isAvailable , showOnlyReorderShoppingCTA);
      } else if (action == 'continue') {
        if (
          multipleAndCheck(!data?.areAllIngredientsAvailable ,
          !data?.isAvailable ,
          data?.isBundleItem ,
          !isAllItemUnavailable ,
            isLocatorPage)
        ) {
          return true;
        }
        if (
          multipleAndCheck((multipleOrCheck((multipleAndCheck(!data?.areAllIngredientsAvailable , !data?.isAvailable , !isAllItemUnavailable)) ,
            (multipleAndCheck(data?.isComboUnavailable , !data?.isBundleItem)))) ,
            isLocatorPage)
        ) {
          return true;
        }
        return multipleOrCheck((multipleAndCheck(!data?.areAllIngredientsAvailable , data?.isAvailable)) , isItemAvailable);
      }
    });
    return list.length > 0;
  };

  if (error) {
    return (
      <ErrorModal error={error} okText={window.okText} value={value} updateModal={updateModal} />
    );
  } else {
    return (
      <>
        {showModal && (
          <Modal
            data-testauto-id={'cartModal-modal'}
            isShown={showModal}
            isClosebtn={isClosebtn}
            title={title}
            description={showDescription()}
            onButtonClick={() => updateModal()}
          >
            {!_isEmpty(favoriteCartData) &&
              !storeClose &&
              unavailableData.map((data: any, index: number) => {
                return checkItemUnAvailability(data) ? (
                  <div className="product__avaliability" key={data?.id}>
                    <div className="product__name">{data.productName}</div>
                    {data?.isComboProductMissingAndIsMeal && (
                      <Heading
                        level="p"
                        title={_get(data, ['productListText'], '')}
                        testAutoId={`cart-modal-product-text-${index}`}
                      />
                    )}
                    <div className="product__items">{favProductDetail(data)}</div>
                    {data?.isComboProductMissingAndIsMeal && (
                      <Heading
                        level="p"
                        className="product__items"
                        title={_get(favDictonary, ['comboError'], '')}
                        testAutoId={`cart-modal-combo-error-${index}`}
                      />
                    )}
                  </div>
                ) : null;
              })}
            <div className="ingredientBtn">
              {componentRenderCheck(multipleAndCheck(!storeClose,
                !_isEmpty(favoriteCartData),
                showButtons('continue'),
                !favoriteCartData?.isDealNotAvailable), (
                <Button
                  testAutoId={CONTINUE_BTN}
                  className="btn w-100"
                    onClick={()=>{
                    onClickContinue();
                    setContextLoader({
                      buttonId: CONTINUE_BTN,
                      isLoading: true,
                    });
                  }}
                >
                  {getContinueButtonText(favDictonary, isRecentOrderPage)}
                </Button>
              ))}

              {componentRenderCheck(multipleAndCheck(!storeClose, showButtons('keep shopping'), favDictonary?.keepShopping), (
                <Button
                  testAutoId={KEEP_SHOPPING_BTN}
                  className="btn btn-border w-100 mt-3"
                  onClick={() => {
                    onClickKeepShopping();
                    setContextLoader({
                      buttonId: KEEP_SHOPPING_BTN,
                      isLoading: true,
                    });
                  }}
                >
                  {favDictonary.keepShopping}
                </Button>
              ))}

              {componentRenderCheck(multipleAndCheck(!storeClose,
                !_isEmpty(favoriteCartData),
                showButtons('start order'),
                showOnlyReorderStartCTA,
                favDictonary?.startOrderButton), (
                <Button
                  testAutoId={START_ORDER_LINK}
                  data-testid={START_ORDER_LINK}
                  className="primary__btn primary__btn--underline startOrder"
                  onClick={() => {
                    onClickStartOrder(
                      removedProductData,
                      isLocatorPage,
                      virtualName,
                      setAnalyticsProducts,
                      setAttemptTracker,
                      orderViewModel,
                    );
                    setContextLoader({
                      buttonId: START_ORDER_LINK,
                      isLoading: true,
                      animationColor: 'grey'
                    });
                  }}
                >
                  {favDictonary.startOrderButton}
                </Button>
              ))}

              {componentRenderCheck(!!favDictonary?.startNewOrder, (
                <Button
                  testAutoId={START_NEW_ORDER_BTN}
                  data-testid={START_NEW_ORDER_BTN}
                  className="btn btn-border w-100 mt-3"
                  onClick={() => {
                    setContextLoader({
                      buttonId: START_NEW_ORDER_BTN,
                      isLoading: true,
                    });
                    if(isCartPage){
                      updateOrderViewModelDeliveryAddress(orderViewModel);
                    }
                    onClickStartOrder(
                      removedProductData,
                      isLocatorPage,
                      virtualName,
                      setAnalyticsProducts,
                      setAttemptTracker,
                      orderViewModel,
                    );
                  }}
                >
                  {favDictonary.startNewOrder}
                </Button>
              ))}

              {componentRenderCheck(multipleAndCheck(favDictonary?.returnToCheckout, window.location.href.toLowerCase().indexOf(window.subwayScript.IsEdit) > 1), (
                <Button
                  testAutoId={RETURN_TO_BAG}
                  data-testid={RETURN_TO_BAG}
                  className="returnToBag"
                  onClick={() => {
                    goToBagPage();
                  }}
                >
                  {favDictonary.returnToBag}
                </Button>
              ))}

              {componentRenderCheck(multipleAndCheck(!storeClose,
                !isRecentOrderPage,
                !isLocatorPage,
                !_isEmpty(favoriteCartData),
                !favoriteCartData?.isDealNotAvailable,
                (!favoriteCartData?.areAllIngredientsAvailable || !favoriteCartData?.isAvailable)), (
                <Button
                  testAutoId={SWITCH_LOCATION_BTN}
                  className="btn btn-border w-100 mt-3"
                  onClick={() => {
                    setContextLoader({
                      buttonId: SWITCH_LOCATION_BTN,
                      isLoading: true,
                      animationColor: GREY
                    });
                    onClickSwitch('switch location', true);
                  }}
                >
                  {favDictonary.switchLocation}
                </Button>
              ))}

              {componentRenderCheck(favoriteCartData?.isDealNotAvailable, (
                <>
                  <Button
                    testAutoId={SWITCH_TO_PICKUP_BTN}
                    className="btn w-100"
                    onClick={() => {
                      setContextLoader({
                        buttonId: SWITCH_TO_PICKUP_BTN,
                        isLoading: true,
                      });
                      navigateToLocatorPage('', setAnalyticsProducts, setAttemptTracker);
                    }}
                  >
                    {(window as any).SwitchtoPickup}
                  </Button>

                  <Button
                    testAutoId={CANCEL_DELIVERY_BTN}
                    className="btn btn-border w-100 mt-3"
                    onClick={() => {
                      setContextLoader({
                        buttonId: CANCEL_DELIVERY_BTN,
                        isLoading: true,
                      });
                      cancelAndKeepDelivery();
                    }}
                  >
                    {(window as any).CancelKeepDelivery}
                  </Button>
                </>
              ))}


              {storeClose && (
                <Button
                  testAutoId={FIND_ANOTHER_RESTAURANT_BTN}
                  className="btn w-100"
                  onClick={() => {
                    setContextLoader({
                      buttonId: FIND_ANOTHER_RESTAURANT_BTN,
                      isLoading: true,
                    });
                    onClickSwitch('find another restaurant', false);
                  }}
                >
                  {favDictonary.findAnotherRestaurant || errorData?.findAnotherRestaurant}
                </Button>
              )}

              {componentRenderCheck(!!favDictonary?.cancelButton, (
                <Button
                  testAutoId={FIND_NEW_LOCATION_CANCEL_BTN}
                  className="btn w-100"
                  onClick={() => {
                    setContextLoader({
                      buttonId: FIND_NEW_LOCATION_CANCEL_BTN,
                      isLoading: true,
                    });
                    orderViewModel.flushCart();
                    if (orderViewModel.orderType == 'delivery')
                      window.location.href =
                        window.subwayScript.navigation.getDeliveryLocatorUrl() +
                        '?zip=' +
                        encodeURIComponent(
                          orderViewModel.store.address + ' ' + orderViewModel.store.city,
                        );
                    else
                      window.location.href =
                        window.subwayScript.navigation.getLocatorUrl() +
                        '?zip=' +
                        encodeURIComponent(
                          orderViewModel.store.address + ' ' + orderViewModel.store.city,
                        );
                  }}
                >
                  {favDictonary.cancelButton}
                </Button>
              ))}
              {componentRenderCheck(!!favDictonary?.acceptButton, (
                <Button
                  testAutoId={FIND_NEW_LOCATION_ACCEPT_BTN}
                  className="btn btn-border w-100 mt-3"
                  onClick={() => {
                    setContextLoader({
                      buttonId: FIND_NEW_LOCATION_ACCEPT_BTN,
                      isLoading: true,
                    });
                    orderViewModel.selectedOffer = null;
                    window.location.href = window.subwayScript.navigation.getMenuUrl(
                      orderViewModel.store.id,
                    );
                  }}
                >
                  {favDictonary.acceptButton}
                </Button>
              ))}

              {componentRenderCheck(multipleOrCheck(multipleAndCheck(isError, !storeClose), isShowOk), (
                <Button
                  testAutoId={`${okText}-btn`}
                  className="btn w-100"
                  onClick={() => {
                    setContextLoader({
                      buttonId: `${okText}-btn`,
                      isLoading: true,
                    });
                    updateModal();
                  }}
                >
                  {okText}
                </Button>
              ))}
            </div>
          </Modal>
        )}
      </>
    );
  }
};

export default CartModal;
